import { Chip } from "@mui/joy";
import { CreditAccountStatus } from "griptonite-api-client/types";

const STATUS_STYLES = {
  ACTIVE: { label: "Active", color: "success" },
  FROZEN: { label: "Frozen", color: "danger" },
  BANNED: { label: "Banned", color: "danger" },
} as const;

export default function AccountStatusChip({ status }: { status: CreditAccountStatus }) {
  const { label, color } = STATUS_STYLES[status];
  return (
    <Chip size="sm" variant="soft" color={color} sx={{ fontWeight: "lg" }}>
      {label}
    </Chip>
  );
}
